import { type ReactNode } from 'react'

import { type IconType } from '@/defs/icon'
import { RELATED_URLS } from '@/defs/misc'
import { type RouteType } from '@/defs/route'

export type NavDeviceType = 'desktop' | 'mobile'

export type NavItemType = {
  backgroundImage?: string
  hash?: string
  icon?: IconType
  iconUrl?: string
  icons?: IconType[]
  id: string
  label?: string | ReactNode
  only?: NavDeviceType
  route?: RouteType
  size?: 'xs' | 'sm'
  submenu?: NavItemType[]
  variant?: 'divider'
}

type QuickLinkBaseType = {
  superscript?: string
}

type QuickLinkDividerType = {
  variant: 'divider'
}

type QuickLinkThemeSwitcherType = {
  variant: 'theme-switcher'
}

type QuickLinkLabelType = {
  icon: IconType
  label: string
}

type QuickLinkSubmenuType = {
  submenu: QuickLinkType[]
  variant: 'submenu'
} & QuickLinkLabelType

type QuickLinkHrefType = {
  href: string
  newTab?: boolean
  variant?: 'patreon' | 'random'
} & QuickLinkLabelType

export type QuickLinkType = QuickLinkBaseType &
  (QuickLinkDividerType | QuickLinkThemeSwitcherType | QuickLinkSubmenuType | QuickLinkHrefType)

export const QUICK_LINKS: QuickLinkType[] = [
  {
    href: '/newsletter',
    icon: 'newspaper',
    label: 'Newsletter',
  },
  {
    icon: 'puzzlePiece',
    label: 'Games',
    submenu: [
      {
        href: 'https://edhrec.com/games/crossword',
        icon: 'crossword',
        label: 'Crossword',
        newTab: true,
      },
      {
        href: 'https://edhrec.com/games/quiz',
        icon: 'squarePollVertical',
        label: 'Personality Quiz',
        newTab: true,
      },
      {
        href: 'https://edhrec.com/games/spellify',
        icon: 'brand-spellify',
        label: 'Spellify',
        newTab: true,
      },
    ],
    variant: 'submenu',
  },
  {
    href: 'https://shop.spacecowmedia.com/collections/edhrec',
    icon: 'shirt',
    label: 'Merch',
    newTab: true,
  },
  {
    variant: 'divider',
  },
  {
    href: '/contact',
    icon: 'envelope',
    label: 'Contact',
  },
  {
    href: '/faq',
    icon: 'circleQuestion',
    label: 'FAQ',
  },
  {
    href: '/random',
    icon: 'shuffle',
    label: 'Random',
    variant: 'random',
  },
  {
    variant: 'theme-switcher',
  },
  {
    href: RELATED_URLS.patreon,
    icon: 'patreon',
    label: 'Patreon',
    newTab: true,
    variant: 'patreon',
  },
]
